/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Overview_Nogiveaways2Inputs */

const id_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada giveaway ditemukan`)
};

const ms_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada pemberian ditemui`)
};

const da_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen giveaways fundet`)
};

const de_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Giveaways gefunden`)
};

const en_us2_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No giveaways found`)
};

const es_es2_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron regalos`)
};

const es_mx2_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron regalos`)
};

const fil_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakitang giveaway`)
};

const fr_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune gratuité trouvée`)
};

const it_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun giveaway trovato`)
};

const hu_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem található ajándék`)
};

const nl_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen giveaways gevonden`)
};

const no_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen giveaways funnet`)
};

const pl_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono rozdań`)
};

const pt_br2_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum jogo grátis encontrado`)
};

const pt_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma oferta grátis encontrada`)
};

const ro_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-au găsit oferte gratuite`)
};

const fi_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmaisjakoja ei löytynyt`)
};

const sv_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga utlottningar hittades`)
};

const vi_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy tặng miễn phí`)
};

const tr_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedava oyun bulunamadı`)
};

const cs_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebyly nalezeny žádné výprodeje`)
};

const bg_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерени безплатни игри`)
};

const ru_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Раздачи не найдены`)
};

const uk_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Роздач не знайдено`)
};

const ar_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على هدايا`)
};

const hi_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई गिवअवे नहीं मिला`)
};

const th_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบของแจกฟรี`)
};

const ja_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配布が見つかりません`)
};

const zh_cn2_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到赠送活动`)
};

const zh_hant1_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到贈送活動`)
};

const ko_offerdetail_overview_nogiveaways2 = /** @type {(inputs: Offerdetail_Overview_Nogiveaways2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 배포 내역이 없음`)
};

/**
* | output |
* | --- |
* | "No giveaways found" |
*
* @param {Offerdetail_Overview_Nogiveaways2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_overview_nogiveaways2 = /** @type {((inputs?: Offerdetail_Overview_Nogiveaways2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Overview_Nogiveaways2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "ms") return ms_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "da") return da_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "de") return de_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "fil") return fil_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "fr") return fr_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "it") return it_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "hu") return hu_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "nl") return nl_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "no") return no_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "pl") return pl_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "pt") return pt_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "ro") return ro_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "fi") return fi_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "sv") return sv_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "vi") return vi_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "tr") return tr_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "cs") return cs_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "bg") return bg_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "ru") return ru_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "uk") return uk_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "ar") return ar_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "hi") return hi_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "th") return th_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "ja") return ja_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_overview_nogiveaways2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_overview_nogiveaways2(inputs)
	return ko_offerdetail_overview_nogiveaways2(inputs)
});
export { offerdetail_overview_nogiveaways2 as "offerDetail.overview.noGiveaways" }